/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assignee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TasksAssignee from 'DesignSystem/TasksAssignee/index'



/** @type {import('Simple/types.js').View} */
export default function Assignee({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Assignee",
  onChange
  
}) {
let requirementNewTaskAssigneeValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'new_task.assignee',
})
let requirementNewTaskAssigneeChangeData = fromData.useDataChange({ viewPath,
context: 'requirement',
path: 'new_task.assignee',
})
  return (<React.Fragment
>
<TasksAssignee
  viewPath={`${viewPath}/TasksAssignee`}
 data="requirement.new_task.assignee"
 assignee_id={requirementNewTaskAssigneeValueData}
 onChange={requirementNewTaskAssigneeChangeData}
/>
{children}
</React.Fragment>)
}